import { all, takeLatest, call, put } from 'redux-saga/effects';

import * as endpoints from './endpoints';
import { request } from '@app/services';
import {
  addHoliday,
  addHolidayFailed,
  addHolidaySuccess,
  getHolidays,
  getHolidaysSuccess,
  getHolidaysFailed,
  deleteHoliday,
  deleteHolidaySuccess,
  deleteHolidayFailed,
  updateHoliday,
  updateHolidaySuccess,
  updateHolidayFailed,
} from './slice';

function* addHolidaySaga(action: ReturnType<typeof addHoliday>): any {
  try {
    const { name, date, image } = action.payload;
    const formData = new FormData();
    formData.append('name', name);
    formData.append('date', date);
    formData.append('image', image);
    const result = yield call(request.post, endpoints.addHoliday, formData);
    yield put(addHolidaySuccess(result.data));
  } catch (err) {
    yield put(addHolidayFailed(err));
  }
}
// ----------------------------------------

function* getHolidaySaga(action: ReturnType<typeof getHolidays>): any {
  try {
    const result = yield call(request.get, endpoints.holidayList);
    yield put(getHolidaysSuccess(result.data));
  } catch (err) {
    yield put(getHolidaysFailed(err));
  }
}
// ----------------------------------------
function* deleteHolidaySaga(action: ReturnType<typeof deleteHoliday>): any {
  try {
    const { id } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.delete, `${endpoints.deleteHoliday}${id}`);
    yield put(deleteHolidaySuccess(result.data));
  } catch (err) {
    yield put(deleteHolidayFailed(err));
  }
}
function* updateHolidaySaga(action: ReturnType<typeof updateHoliday>): any {
  try {
    const { id, name, date, image } = action.payload;
    const formData = new FormData();
    formData.append('name', name);
    formData.append('date', date);
    formData.append('image', image);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateHoliday}${id}`, formData);
    yield put(updateHolidaySuccess(result.data));
  } catch (err) {
    yield put(updateHolidayFailed(err));
  }
}

function* holidaySagas() {
  yield all([
    takeLatest(addHoliday, addHolidaySaga),
    takeLatest(
      [getHolidays, addHolidaySuccess, deleteHolidaySuccess, updateHolidaySuccess],
      getHolidaySaga
    ),
    takeLatest(deleteHoliday, deleteHolidaySaga),
    takeLatest(updateHoliday, updateHolidaySaga),
  ]);
}

export { holidaySagas };
